export const parseTextWithLinksAndFormatting = (
  text,
  links,
  asString = false,
) => {
  const parts = text.split(/(\[.*?\]|<i>.*?<\/i>)/);

  const processLink = (part, index, asString) => {
    const linkMatch = part.match(/\[(.*?)\]/);
    if (linkMatch && links[linkMatch[1]]) {
      const link = links[linkMatch[1]];
      if (asString) {
        return `<a href="${link.url}">${link.text}</a>`;
      } else {
        return (
          <a key={index} href={link.url}>
            {link.text}
          </a>
        );
      }
    }

    return null;
  };

  const processItalic = (part, index, asString) => {
    const italicMatch = part.match(/<i>(.*?)<\/i>/);
    if (italicMatch) {
      if (asString) {
        return `${italicMatch[1]}`;
      } else {
        return <i key={index}>{italicMatch[1]}</i>;
      }
    }

    return null;
  };

  const processedParts = parts.map(
    (part, index) =>
      processLink(part, index, asString) ||
      processItalic(part, index, asString) ||
      part,
  );

  return asString ? processedParts.join("") : processedParts;
};
